import React, { useEffect, JSX } from 'react';
import { Typography, LinearProgress, Icon } from '@ace-clublabs/shared-component-library';
import Box from '@mui/material/Box';
import { LoadingInfo } from '../application/models/LoadingInfo';

export interface LoadingProps {
  loadingInfo: LoadingInfo;
  maxSteps: number;
  currentStep: number;
  displaySteps?: number;
  estimatedTimeInSeconds?: number;
}

export const LoadingIndicator: (props: LoadingProps) => JSX.Element = ({
  loadingInfo,
  currentStep,
  displaySteps,
  estimatedTimeInSeconds,
}) => {
  const [progress, setProgress] = React.useState(0);
  const [showSteps, setShowSteps] = React.useState<string[]>([]);

  const intervalTime = 100;

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const timeInSeconds = estimatedTimeInSeconds ?? 11;
        const intervalProgress = (intervalTime / (timeInSeconds * 1000)) * 100;
        return Math.min(oldProgress + intervalProgress, 100);
      });
    }, intervalTime);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const message = showSteps?.length ? showSteps[showSteps.length - 1] : 'Finalizing membership details';

  useEffect(() => {
    setShowSteps(loadingInfo.loadingDetails.slice(Math.max(currentStep - (displaySteps ?? currentStep), 0)));
  }, [loadingInfo, displaySteps, currentStep]);

  return (
    <>
      <div className="loading-view">
        <div className="progress-bar-container">
          <Box sx={{ width: '100%' }}>
            <LinearProgress
              className="progress-bar"
              variant="determinate"
              value={progress}
              sx={{ height: '8px', backgroundColor: '#DFF0FE' }}
            />
          </Box>
        </div>
        <div className="loading-info">
          <Icon iconName="circle-check-regular" color="primary" sx={{ fontSize: '1.5rem' }} />
          <div className="loading-description-container">
            <Typography variant="b1Medium">
              <span>{message}</span>
            </Typography>
            <Typography variant="b1Regular">Please don't refresh the page or press the back button.</Typography>
          </div>
        </div>
      </div>
    </>
  );
};
